import apiClient from '../../../shared/services/apiClient';
import { unwrapEnvelopeData, unwrapList } from '../../../shared/services/apiHelpers';

export function normalizePipelineStage(row) {
  if (!row || typeof row !== 'object') return null;
  const id = row.id ?? row.Id;
  const name = row.leadStatusName ?? row.LeadStatusName ?? row.name;
  if (!id || !name) return null;
  return {
    id: String(id),
    name: String(name),
    leadStatusName: String(name),
    color: row.color ?? row.Color ?? null,
    sortOrder: row.sortOrder ?? row.SortOrder ?? 0,
  };
}

function normalizeStages(payload) {
  return unwrapList(unwrapEnvelopeData(payload)).map(normalizePipelineStage).filter(Boolean);
}

const LeadStatusService = {
  getAllLeadStatus: async () => {
    const response = await apiClient.get('/crm/pipeline-stages');
    return normalizeStages(response);
  },

  getPipelineStagesByClientId: async (clientId) => {
    const response = await apiClient.get(`/crm/pipeline-stages/by-client/${clientId}`);
    return normalizeStages(response);
  },

  getPipelineStagesByIndustryId: async (industryId) => {
    const response = await apiClient.get(`/crm/pipeline-stages/by-industry/${industryId}`);
    return normalizeStages(response);
  },

  createPipelineStage: async (dto) => {
    const response = await apiClient.post('/crm/pipeline-stages', dto);
    return unwrapEnvelopeData(response);
  },

  updatePipelineStage: async (id, dto) => {
    const response = await apiClient.put(`/crm/pipeline-stages/${id}`, dto);
    return unwrapEnvelopeData(response);
  },

  deletePipelineStage: async (id) => {
    const response = await apiClient.delete(`/crm/pipeline-stages/${id}`);
    return unwrapEnvelopeData(response);
  },
};

export default LeadStatusService;
